import Avatar from '@material-ui/core/Avatar';
import LazyFlag from 'components/LazyFlag/LazyFlag';
import styled from 'styled-components';

export const StyledAvatar = styled(Avatar)`
    border-radius: 0;
    background-color: transparent;
`;

export const StyledFlag = styled(LazyFlag)`
    max-width: 100%;
`;
